import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DoorModels } from '@models/door.model';
import { AuthSrcDirective } from '../../directives/auth-src.directive';
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { ThumbnailsService } from '../../../development/thumbnails.service';

@Component({
  selector: 'ui-door-icon',
  templateUrl: './ui-door-icon.component.html',
  styleUrls: ['./ui-door-icon.component.scss'],
  imports: [AuthSrcDirective, NgIf, TranslatePipe, MatIcon, MatMenu, MatMenuItem, MatTooltip],
})
export class UiDoorIconComponent implements OnInit {
  @Output() add = new EventEmitter<void>();
  @Output() addExisting = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();

  @Input() door: DoorModels.Door;
  @Input() small = false;
  @Input() allowDelete = false;

  img;

  constructor(private readonly thumbnailsService: ThumbnailsService) {}

  ngOnInit(): void {
    const door = this.door;
    const trainingBase = this.thumbnailsService.getTrainingThumbnailsBaseUrl(door.edgeId, false);
    this.img = `${trainingBase}/training/${door.edgeId}/${door.cameraId}/${door.closeState}`;
  }
}
